import script from "./BaseDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./BaseDropdown.vue?vue&type=style&index=0&id=a5f983b4&lang=scss"

const __exports__ = script;

export default __exports__